/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export class DateUtil {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public static setActivityTimeZone(hour:number):void {
			DateUtil.activityTimezoneOffset = hour * 60 * 60 * 1000;
		}

		public static utcToActivityTimeZone(utcTime:number):number {
			return utcTime + DateUtil.activityTimezoneOffset;
		}

		public static setUtcTime(date:Date, utcTime:number):void {
			date.setTime(utcTime - DateUtil.localTimezoneOffset);
		}

		public static createUtcDate(utcTime:number):Date {
			return new Date(utcTime - DateUtil.localTimezoneOffset);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		// UTCから活動ログへの時差（ミリ秒）
		private static activityTimezoneOffset:number = 0;

		// UTCからローカルへの時差（ミリ秒）
		private static localTimezoneOffset:number = -(new Date()).getTimezoneOffset() * 60 * 1000;
	}
}
